import { render, staticRenderFns } from "./OptionDropdownSelect.vue?vue&type=template&id=fb8ba4e0&scoped=true"
import script from "./OptionDropdownSelect.vue?vue&type=script&lang=js"
export * from "./OptionDropdownSelect.vue?vue&type=script&lang=js"
import style0 from "./OptionDropdownSelect.vue?vue&type=style&index=0&id=fb8ba4e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb8ba4e0",
  null
  
)

export default component.exports